export default __webpack_public_path__ + "static/media/expert-main.7255cdbe.png";